import InternalMessagesAPI from 'dashboard/api/internal/messages';
import { createStore } from '../storeFactory';

export default createStore({
  name: 'InternalMessages',
  API: InternalMessagesAPI,
  actions: mutationTypes => ({
    fetchForRoom: async ({ commit }, { roomId, page = 1 }) => {
      const { data } = await InternalMessagesAPI.get(roomId, { page });
      commit(mutationTypes.SET, data.payload);
      return data;
    },
    send: async ({ commit }, { roomId, content, files }) => {
      const { data } = await InternalMessagesAPI.create(roomId, {
        content,
        files,
      });
      commit(mutationTypes.UPSERT, data);
      return data;
    },
    upsert: ({ commit }, data) => {
      commit(mutationTypes.UPSERT, data);
    },
  }),
});
